import { getClassName } from './getClassName';
import s from './CatsCollection.module.css';
import { MDBRipple } from 'mdb-react-ui-kit';
import { BreedNameLabel } from 'components/BreedNameLabel/BreedNameLabel';
import { HeartLabel } from 'components/HeartLabel/HeartLabel';

import { NavLink, useLocation } from 'react-router-dom';

const CatCard = ({
  url,
  id,
  isActive,
  index,
  path,
  destination,
  actualSyleLabelHover,
  getBreedName,
  handlerClick,
}) => {
  const { pathname } = useLocation();
  return (
    <div id={id} className={s[getClassName(index).className]} key={id}>
      <NavLink to={path} state={{ path: pathname }}>
        <MDBRipple
          className="bg-image hover-overlay rounded"
          rippleTag="div"
          rippleColor="light"
          key={id}
          onClick={e => {
            handlerClick(e, id);
          }}
        >
          <img
            key={id}
            src={url}
            width={getClassName(index).width}
            height={getClassName(index).height}
            style={{ borderRadius: '20px', objectFit: 'cover' }}
            loading={'lazy'}
            alt={'cats'}
          />
          <div href="#!">
            <div className="mask" style={actualSyleLabelHover} key={id}>
              {destination === 'breed' && (
                <BreedNameLabel name={getBreedName(id)} />
              )}

              {destination === 'gallery' &&
                (isActive ? (
                  <HeartLabel active={true} />
                ) : (
                  <HeartLabel active={false} />
                ))}

              {destination === 'favourites' &&
                (isActive ? (
                  <HeartLabel active={true} />
                ) : (
                  <HeartLabel active={false} />
                ))}
            </div>
          </div>
        </MDBRipple>
      </NavLink>
    </div>
  );
};

export { CatCard };
